import { useState, useEffect } from "react";

const Input = ({
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  icon,
  required = false,
  className = "",
  validationRegex,
  errorMessage,
  onValidationChange,
  validateOnBlur = true,
  showPasswordToggle = false,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Password type için toggle özelliği
  const isPasswordType = type === "password";
  const isDateType = type === "date";
  const actualType = isPasswordType && showPassword ? "text" : type;
  // Native date inputs hide placeholders, so show a text field until focused/value exists
  const computedType =
    isDateType && !isFocused && !value ? "text" : actualType;

  const validate = (inputValue) => {
    if (!validationRegex) {
      setIsValid(true);
      if (onValidationChange) {
        onValidationChange(name, true, "");
      }
      return true;
    }

    const trimmedValue = inputValue?.trim() || "";
    
    // Eğer required değilse ve boşsa, validation geçerli sayılır
    if (!required && trimmedValue === "") {
      setIsValid(true);
      setShowError(false);
      if (onValidationChange) {
        onValidationChange(name, true, "");
      }
      return true;
    }

    // Required ise ve boşsa
    if (required && trimmedValue === "") {
      setIsValid(false);
      setShowError(true);
      if (onValidationChange) {
        onValidationChange(name, false, errorMessage || "Bu alan zorunludur");
      }
      return false;
    }

    // Regex kontrolü
    const regex = new RegExp(validationRegex);
    const valid = regex.test(trimmedValue);
    setIsValid(valid);
    setShowError(!valid);
    
    if (onValidationChange) {
      onValidationChange(name, valid, valid ? "" : (errorMessage || "Geçersiz format"));
    }
    
    return valid;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(e);
    
    // Eğer hata gösteriliyorsa ve değer değiştiyse tekrar validate et
    if (showError) {
      validate(newValue);
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (validateOnBlur) {
      validate(value);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleWheel = (event) => {
    if (type === "number") {
      event.target.blur();
    }
  };

  // İlk render'da ve value değiştiğinde validate et (eğer validateOnBlur false ise)
  useEffect(() => {
    if (!validateOnBlur && value) {
      validate(value);
    }
  }, [value, validateOnBlur]);

  return (
    <div>
      <div
        className={`input-group${isFocused ? " input-group-focus" : ""}${!isValid && showError ? " has-error" : ""} ${className}`}
      >
        <input
          type={computedType}
          className={`form-control${!isValid && showError ? " is-invalid" : ""}`}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onWheel={handleWheel}
          required={required}
          {...props}
        />
        {isPasswordType && showPasswordToggle && (
          <span 
            className="input-group-addon" 
            onClick={() => setShowPassword(!showPassword)}
            style={{ cursor: "pointer" }}
          >
            <i className={`zmdi ${showPassword ? "zmdi-eye-off" : "zmdi-eye"}`}></i>
          </span>
        )}
        {icon && !showPasswordToggle && (
          <span className="input-group-addon">
          <i className={icon.startsWith('zmdi zmdi-') ? icon : icon.startsWith('zmdi-') ? `zmdi ${icon}` : icon}></i>
          </span>
        )}
      </div>
      {!isValid && showError && errorMessage && (
        <div className="invalid-feedback" style={{ display: "block", color: "#dc3545", fontSize: "12px", marginTop: "0.25rem" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default Input;

